import type { Catalog } from "./backoffice.en.ts";

export const de = {
	backoffice: {
		setup: {
			draftSavedTitle: "Entwurf gespeichert",
			draftLocation:
				"Der Entwurf bleibt auf diesem Gerät in diesem Browser und ist Ihrem angemeldeten Konto zugeordnet.",
			draftResume:
				"Öffnen Sie „Kunde hinzufügen“ erneut, um hier fortzusetzen. Auf einem anderen Gerät oder in einem anderen Browser ist der Entwurf nicht verfügbar.",
			draftEffect:
				"Es wurde keine Lizenz ausgestellt und nichts in Google Cloud oder GitHub eingerichtet.",

			firebasePurpose:
				"Hier wählen Sie das bestehende Projekt für die App. Es wird keine Datei benötigt.",
			providerHint: "Vollständiger Ressourcenname aus Google Cloud",
			officialGuide: "Google-Anleitung lesen",
			providerError:
				"Den vollständigen Ressourcennamen aus der Anleitung einfügen.",
			accountError:
				"Die Dienstkonto-E-Mail mit der Endung .iam.gserviceaccount.com einfügen.",
			hostnameError: "Einen Hostnamen ohne https:// oder Pfad eingeben.",

			heading: "Kunde einrichten",
			close: "Schließen",
			clientStep: "Kunde",
			clientDesc: "Name und Laufzeit",
			projectStep: "Firebase-Projekt",
			projectDesc: "Projekt-ID aus der Firebase Console kopieren",
			accessStep: "Zugriff für die Bereitstellung",
			accessDesc: "Zwei Angaben aus Google Cloud kopieren",
			reviewStep: "Prüfen und verbinden",
			reviewDesc: "Erst hier wird die Lizenz ausgestellt",
			next: "Weiter",
			saveDraft: "Als Entwurf speichern",
			openFirebase: "Firebase Console öffnen",
			findProvider: "Anbieter finden – Anleitung öffnen",
			findAccount: "Dienstkonto finden – Anleitung öffnen",
			providerLabel: "Workload-Identity-Anbieter",
			accountLabel: "Dienstkonto für die Bereitstellung",
			accessPrerequisite:
				"Der Kunde braucht einen eingerichteten Workload-Identity-Anbieter und ein berechtigtes Dienstkonto. Diese Angaben verbinden die bestehende Einrichtung; sie erstellen keine Cloud-Ressourcen.",
			setupGuide: "Noch nicht eingerichtet? Google-Anleitung öffnen",
			consequence:
				"Die Lizenz wird unterschrieben und die GitHub-Umgebung eingerichtet. Es wird noch keine App bereitgestellt.",
			advanced: "Andere Einrichtungswege",
			openConsole: "Console öffnen",
			understood: "Verstanden",
			firebase1:
				"Firebase Console öffnen und das Projekt des Kunden auswählen.",
			firebase2:
				"Neben „Projektübersicht“ auf das Zahnrad klicken. „Projekteinstellungen“ → „Allgemein“ öffnen.",
			firebase3:
				"Unter „Ihr Projekt“ die „Projekt-ID“ kopieren und hier einfügen. Nicht den Projektnamen oder die Projektnummer.",
			providerTitle: "Workload-Identity-Anbieter finden",
			provider1:
				"Google Cloud Console öffnen und das Projekt mit dem eingerichteten Anbieter auswählen.",
			provider2:
				"„IAM & Verwaltung“ → „Workload Identity-Föderation“ öffnen. Den für GitHub eingerichteten Pool und dessen Anbieter auswählen.",
			provider3:
				"Den vollständigen Ressourcennamen kopieren: projects/PROJEKTNUMMER/locations/global/workloadIdentityPools/POOL-ID/providers/ANBIETER-ID. Hier einfügen, nicht den Anzeigenamen.",
			providerFile:
				"Wenn kein passender Pool oder Anbieter existiert, zuerst die verlinkte Google-Anleitung zur GitHub-Einrichtung durchführen.",
			accountTitle: "Dienstkonto-Adresse finden",
			account1:
				"Google Cloud Console öffnen und das Projekt mit dem Dienstkonto auswählen.",
			account2:
				"„IAM & Verwaltung“ → „Dienstkonten“ öffnen. Das bereits für die Bereitstellung berechtigte Konto auswählen.",
			account3:
				"Die E-Mail-Adresse kopieren und hier einfügen, zum Beispiel deploy@kunden-projekt.iam.gserviceaccount.com.",
			accountFile:
				"Es wird kein Schlüssel benötigt. Keine JSON-Schlüsseldatei erstellen oder hochladen.",
		},
		brand: "Revia",
		retry: "Erneut versuchen",
		cancel: "Abbrechen",
		denied: "Dieses Konto darf das nicht.",
		final: "Das hat nicht geklappt, und ein neuer Versuch ändert daran nichts.",
		nav: {
			requests: "Anfragen",
			licences: "Lizenzen",
			visits: "Besuche",
			preferences: "Voreinstellungen",
			brandPreferences: "{{brand}} — Voreinstellungen",
		},
		session: {
			checking: "Anmeldung wird geprüft",
		},
		notStaff: {
			title: "Dieses Konto gehört nicht zum Revia-Team",
			signedInAs: "Angemeldet als {{email}}.",
			switch: "Anderes Konto verwenden",
		},
		notice: {
			loading: "Hinweise für das Team werden geprüft",
			failed: "Die Hinweise für das Team konnten nicht geprüft werden",
			signingInAs: "Anmeldung als",
			continue: "Weiter",
			recordFailed:
				"Ihre Bestätigung wurde nicht gespeichert. Bitte erneut versuchen.",
		},
		requests: {
			waitingLabel: "offene Anfragen",
			loading: "Zugangsanfragen werden geladen",
			failed: "Anfragen konnten nicht geladen werden",
			show: "Anfragen zeigen",
			waiting: "Wartend {{count}}",
			later: "Später {{count}}",
			grantedChip: "Freigegeben {{count}}",
			noneYet:
				"Noch keine Anfragen. Sie kommen über das Formular auf revia.to hierher.",
			noneWaiting: "Nichts wartet.",
			noneLater: "Nichts für später zurückgelegt.",
			noneGranted: "Noch niemand freigegeben.",
			kind: "Art",
			phone: "Telefon",
			email: "E-Mail",
			mailLanguage: "Sprache der E-Mails",
			requested: "Angefragt",
			kinds: {
				theatre: "Theater",
				concerts: "Konzerte",
				club: "Club",
				festival: "Festival",
				comedy: "Comedy",
				sports: "Sport",
				other: "Anderes",
			},
			languages: { de: "Deutsch", en: "Englisch" },
			on: "am {{date}}",
			expires: "Läuft ab {{when}}.",
			setAside: "Für später zurückgelegt {{when}}. Läuft ab {{expires}}.",
			grantedOn: "Freigegeben {{when}}.",
			grantedMailed: "Freigegeben {{when}}. Der Anmeldelink ging an {{email}}.",
			setLater: "Später",
			setLaterFor: "{{organization}} für später zurücklegen",
			backToWaiting: "Zurück zu Wartend",
			backToWaitingFor: "{{organization}} zurück zu Wartend",
			approve: "Freigeben",
			approveFor: "{{organization}} freigeben",
			foundAsFor: "Name, unter dem {{organization}} gegründet wird",
			foundAsHint: "Die Freigabe gründet die Organisation unter diesem Namen.",
			foundAsInvalid: "Geben Sie einen Namen mit höchstens 200 Zeichen ein.",
			retry: "Hat nicht geklappt. Bitte erneut versuchen.",
			denied: "Dieses Konto darf Anfragen nicht bearbeiten.",
			missing: "Diese Anfrage gibt es nicht mehr.",
			settled: "Diese Anfrage ist schon freigegeben.",
		},
		licences: {
			loading: "Lizenzen werden geladen",
			failed: "Lizenzen konnten nicht geladen werden",
			countOne: "Lizenz",
			countOther: "Lizenzen",
			add: "Kunde hinzufügen",
			emptyTitle: "Noch keine Lizenzen",
			emptyBody:
				"Fügen Sie einen hinzu, sobald Revent in der Google Cloud eines Kunden läuft.",
			client: "Kunde",
			project: "Firebase-Projekt",
			signed: "Unterschrieben",
			licence: "Lizenz",
			ends: "Endet {{date}}",
			grace: "Kulanzzeit bis {{date}}",
			readOnlySince: "Nur lesen seit {{date}}",
			sign: "Neu unterschreiben",
			signFor: "Lizenz für {{client}} neu unterschreiben",
			token: "Token",
			tokenFor: "Lizenz-Token für {{client}}",
		},
		visits: {
			heading: "Besuche",
			span: "{{from}} – {{to}} (UTC)",
			show: "Zeitraum",
			days7: "7 Tage",
			days30: "30 Tage",
			loading: "Besuchsbericht wird geladen",
			failed: "Der Besuchsbericht konnte nicht geladen werden",
			pageViews: "Seitenaufrufe",
			views: "{{count}} Aufrufe",
			empty: "Keine Seitenaufrufe in diesem Zeitraum.",
			referrers: "Verweis",
			unreferred: "Ohne Verweis",
			sources: "Kampagnenquelle",
			other: "Andere",
			noSources: "Keine Kampagne in diesem Zeitraum.",
		},
		sign: {
			heading: "Lizenz unterschreiben",
			projectId: "Firebase-Projekt-ID",
			idChars: "Nur Kleinbuchstaben, Ziffern und Bindestriche.",
			idStart: "Mit einem Buchstaben beginnen.",
			idLength: "6 bis 30 Zeichen; hier sind es {{count}}.",
			idEnd: "Mit einem Buchstaben oder einer Ziffer enden.",
			endDate: "Enddatum",
			graceDays: "Kulanztage",
			days: "Tage",
			summary:
				"{{client}} ist bis {{end}} lizenziert, ab {{readOnly}} nur lesen (UTC).",
			summaryNone: "{{client}} ist bis zum gewählten Enddatum lizenziert.",
			replacesEnding: "Ersetzt die Lizenz, die {{date}} endet.",
			replacesEnded: "Ersetzt die Lizenz, die {{date}} endete.",
			pickAfterToday: "Bitte einen Tag nach heute wählen.",
			pickEnd: "Bitte ein Enddatum wählen.",
			passed: "Dieser Tag ist vorbei. Bitte einen späteren wählen.",
			deliversAutomatically:
				"Revias GitHub-App setzt danach LICENCE_TOKEN in {{environment}}.",
			deliversByHand:
				"Setzen Sie das Token danach als LICENCE_TOKEN in {{environment}}.",
			notSetUp:
				"Das Unterschreiben ist für Revia noch nicht eingerichtet, also wurde nichts unterschrieben. Das liegt nicht an Ihnen.",
			submit: "Lizenz unterschreiben",
			retry: "Fehler · Unterschreiben",
		},
		client: {
			heading: "Kunde hinzufügen",
			client: "Kunde",
			environment: "GitHub-Umgebung: {{name}}",
			environmentEmpty: "Die GitHub-Umgebung wird danach benannt.",
			environmentNone:
				"Der Name braucht einen Buchstaben oder eine Ziffer für die GitHub-Umgebung.",
			serviceAccountHint: "Die Adresse des Deploy-Dienstkontos des Kunden",
			mainHostname: "Eigene Domain (optional)",
			mainHostnameHint:
				"Erst, wenn sie an die Hosting-Site des Kunden angebunden ist",
			pathway: "GitHub einrichten",
			automatic: "Automatisch",
			commands: "Befehle",
			github: "Auf github.com",
			checking: "GitHub wird geprüft…",
			checkFailed: "GitHub konnte nicht geprüft werden.",
			connected:
				"Revias GitHub-App richtet {{environment}} in ReVia-Workspace/Revent ein.",
			notConnected:
				"GitHub ist nicht verbunden. „GitHub verbinden“ registriert Revias App in ReVia-Workspace; eine Inhaberin oder ein Inhaber der Organisation schließt das auf github.com ab und installiert sie in Revent.",
			connectGitHub: "GitHub verbinden",
			notInstalled:
				"Revias GitHub-App ist registriert, aber nicht in Revent installiert.",
			install: "App installieren",
			recheck: "Erneut prüfen",
			connect: "Automatisch verbinden",
			connectRetry: "Fehler · Erneut verbinden",
			signFirst:
				"Zuerst wird die Lizenz unterschrieben; ihr Token kommt dann in die Umgebung.",
			commandsLine:
				"Führen Sie diese in einem bei GitHub angemeldeten Terminal aus (gh auth login). Der Secret-Befehl fragt nach dem Wert: Fügen Sie das Token an der verdeckten Eingabe ein.",
			commandsSubject: "Befehle",
			copyCommands: "Befehle kopieren",
			openEnvironments: "Revents Umgebungen öffnen",
			environmentSubject: "Umgebungsname",
			step1: "Neue Umgebung mit dem Namen:",
			step2:
				"Deployment branches and tags → Selected branches and tags → Add rule → Tag, mit dem Muster:",
			step3: "Umgebungsvariablen:",
			step4: "Umgebungs-Secret LICENCE_TOKEN:",
			step5:
				"Settings → Secrets and variables → Actions → Variables: Den Namen in DEPLOY_ENVIRONMENTS dem JSON-Array hinzufügen:",
			openVariables: "Variablen des Repositorys öffnen",
		},
		steps: {
			licence: "Lizenz",
			environment: "Umgebung",
			branchPolicy: "Deploys nur aus v*-Tags",
			variables: "Variablen",
			secret: "Secret LICENCE_TOKEN",
			roster: "In DEPLOY_ENVIRONMENTS eingetragen",
			done: "erledigt",
			failed: "fehlgeschlagen",
			skipped: "nicht ausgeführt",
			credentials:
				"GitHub hat die Zugangsdaten der App abgelehnt. Registrieren Sie sie mit „GitHub verbinden“ neu.",
			forbidden:
				"GitHub hat abgelehnt. Mit GitHub Free brauchen Umgebungen eines privaten Repositorys und ihre Secrets GitHub Team; sonst fehlt der App diese Berechtigung.",
			notFound:
				"GitHub findet das Repository nicht, oder die App ist dort nicht installiert.",
			rejected:
				"GitHub hat abgelehnt. Mit GitHub Free brauchen Umgebungen eines privaten Repositorys GitHub Team.",
			rosterInvalid:
				"DEPLOY_ENVIRONMENTS enthält kein JSON-Array von Namen. Korrigieren Sie es zuerst auf github.com.",
			unexpected: "GitHub antwortete mit HTTP {{status}}.",
			manual:
				"Die Lizenz ist unterschrieben. Den Rest von Hand erledigen: „Befehle“ oder „Auf github.com“ wählen.",
		},
		token: {
			heading: "Lizenz-Token für {{client}}",
			line: "Hinterlegen Sie es als Secret LICENCE_TOKEN in der Umgebung des Kunden in ReVia-Workspace/Revent. Führen Sie dies mit dem Umgebungsnamen des Kunden aus und fügen Sie das Token an der verdeckten Eingabe ein:",
			command: "Befehl",
			value: "Token",
			subject: "Lizenz-Token",
			done: "Fertig",
			onGitHub: "Auf github.com",
		},
	},
} satisfies Catalog;
